import { Stack } from '@mui/material';
import type { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '~/components/organisms/Header';
import { CSPHelmet } from '~/components/utilities/CSPHelmet';
import { useTrackingProviders } from '~/hooks/useTrackingProviders';
import { QuickSightEmbedProvider } from '~/providers/QuickSightEmbedProvider';

export const AuthenticatedLayout: FC = () => {
  useTrackingProviders();

  return (
    <>
      <CSPHelmet />
      <Stack minHeight="100dvh">
        <Header />
        <Stack component="main" flex="1">
          <QuickSightEmbedProvider>
            <Outlet />
          </QuickSightEmbedProvider>
        </Stack>
      </Stack>
    </>
  );
};
